import React, { useEffect, useState, useCallback } from "react";
import { Grid, TextField, MenuItem, FormControlLabel, Switch, Box, Typography } from "@mui/material";
import useStyles from "./style";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AvailablebanksApi from "Services/Availablebanks";
import dayjs from "dayjs";
import { GetCountries, GetState, GetCity } from "react-country-state-city";

const BankInformation = ({ onRef, formikbank, driverId, setsubmitButton, setSkipButton }) => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  useEffect(() => {
    GetCountries().then((result) => setCountriesList(result));
  }, []);

  useEffect(() => {
    if (formikbank.values.country) {
      GetState(parseInt(formikbank.values.country)).then((result) => setStateList(result));
    }
  }, [formikbank.values.country]);

  useEffect(() => {
    if (formikbank.values.country && formikbank.values.state) {
      GetCity(
        parseInt(formikbank.values.country),
        parseInt(formikbank.values.state)
      ).then((result) => setCitiesList(result));
    }
  }, [formikbank.values.country, formikbank.values.state]);

  return (
    <Box className={classes.BasicInformationStyles}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="subtitle1" fontWeight="600" sx={{ fontFamily: "'Inter', sans-serif" }}>
          Bank details
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={isEditable}
              onChange={(e) => setIsEditable(e.target.checked)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#10b981",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#10b981",
                },
                "& .MuiSwitch-switchBase": {
                  color: "#ef4444",
                },
                "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                  backgroundColor: "#ef4444",
                },
              }}
            />
          }
          label="Enable Edit"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              fontWeight: 500,
            },
          }}
        />
      </Box>

      <Box style={{ opacity: isEditable ? 1 : 0.6, pointerEvents: isEditable ? "auto" : "none" }}>
        <Grid container spacing={2}>
          {/* Bank Account Number */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Bank Account Number</Typography>
            <TextField
              disabled={!isEditable}
              id="bank_account_number"
              name="bank_account_number"
              placeholder="Enter bank account number"
              value={formikbank.values.bank_account_number}
              onChange={formikbank.handleChange}
              error={formikbank.touched.bank_account_number && Boolean(formikbank.errors.bank_account_number)}
              helperText={formikbank.touched.bank_account_number && formikbank.errors.bank_account_number}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Date of Birth */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Date of Birth</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                disabled={!isEditable}
                value={formikbank.values.dob ? dayjs(formikbank.values.dob) : null}
                onChange={(newValue) => {
                  const formattedDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : "";
                  formikbank.setFieldValue("dob", formattedDate);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="dob"
                    id="dob"
                    error={formikbank.touched.dob && Boolean(formikbank.errors.dob)}
                    helperText={formikbank.touched.dob && formikbank.errors.dob}
                    fullWidth
                    size="small"
                    variant="outlined"
                    className={classes.formInput}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* Sort Code */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Sort Code</Typography>
            <TextField
              name="sort_code"
              id="sort_code"
              placeholder="Enter sort code"
              value={formikbank.values.sort_code}
              onChange={formikbank.handleChange}
              disabled={!isEditable}
              error={formikbank.touched.sort_code && Boolean(formikbank.errors.sort_code)}
              helperText={formikbank.touched.sort_code && formikbank.errors.sort_code}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Address</Typography>
            <TextField
              name="Address"
              id="Address"
              placeholder="Enter address"
              value={formikbank.values.Address}
              onChange={formikbank.handleChange}
              disabled={!isEditable}
              error={formikbank.touched.Address && Boolean(formikbank.errors.Address)}
              helperText={formikbank.touched.Address && formikbank.errors.Address}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Postal Code */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Postal Code</Typography>
            <TextField
              name="postelcode"
              id="postelcode"
              placeholder="Enter postal code"
              value={formikbank.values.postelcode}
              onChange={formikbank.handleChange}
              disabled={!isEditable}
              error={formikbank.touched.postelcode && Boolean(formikbank.errors.postelcode)}
              helperText={formikbank.touched.postelcode && formikbank.errors.postelcode}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Country */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Country</Typography>
            <TextField
              select
              name="country"
              id="country"
              value={formikbank.values.country || ""}
              onChange={formikbank.handleChange}
              disabled={!isEditable}
              error={formikbank.touched.country && Boolean(formikbank.errors.country)}
              helperText={formikbank.touched.country && formikbank.errors.country}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
              SelectProps={{
                displayEmpty: true,
                renderValue: (v) => {
                  const selectedCountry = countriesList.find((c) => c.id === parseInt(v));
                  return selectedCountry ? selectedCountry.name : <span style={{ color: "#9ca3af" }}>Select Country</span>;
                },
              }}
            >
              {countriesList.map((_country) => (
                <MenuItem key={_country.id} value={_country.id}>
                  {_country.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* State */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>State</Typography>
            <TextField
              select
              name="state"
              id="state"
              value={formikbank.values.state || ""}
              onChange={formikbank.handleChange}
              disabled={!isEditable || !formikbank.values.country}
              error={formikbank.touched.state && Boolean(formikbank.errors.state)}
              helperText={formikbank.touched.state && formikbank.errors.state}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
              SelectProps={{
                displayEmpty: true,
                renderValue: (v) => {
                  const selectedState = stateList.find((s) => s.id === parseInt(v));
                  return selectedState ? selectedState.name : <span style={{ color: "#9ca3af" }}>Select State</span>;
                },
              }}
            >
              {stateList.map((_state) => (
                <MenuItem key={_state.id} value={_state.id}>
                  {_state.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>City</Typography>
            <TextField
              select
              name="city"
              id="city"
              value={formikbank.values.city || ""}
              onChange={formikbank.handleChange}
              disabled={!isEditable || !formikbank.values.state}
              error={formikbank.touched.city && Boolean(formikbank.errors.city)}
              helperText={formikbank.touched.city && formikbank.errors.city}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
              SelectProps={{
                displayEmpty: true,
                renderValue: (v) => {
                  const selectedCity = citiesList.find((c) => c.id === parseInt(v));
                  return selectedCity ? selectedCity.name : <span style={{ color: "#9ca3af" }}>Select City</span>;
                },
              }}
            >
              {citiesList.map((_city) => (
                <MenuItem key={_city.id} value={_city.id}>
                  {_city.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default BankInformation;
